import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = { class: "success-toast-text" };
import { computed, getCurrentInstance, watch, onUnmounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SuccessToast',
    props: {
        count: {},
        message: { default: '{count} transaction{s} categorised' },
        duration: { default: 2500 }
    },
    emits: ["update:count"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const cookies = getCurrentInstance()?.appContext.config.globalProperties.$cookies;
        const safeTop = computed(() => parseInt(cookies?.get('st') ?? '0'));
        const displayMessage = computed(() => props.message
            .replace('{count}', String(props.count))
            .replace('{s}', props.count === 1 ? '' : 's'));
        let timer = null;
        watch(() => props.count, (n) => {
            if (timer) {
                window.clearTimeout(timer);
                timer = null;
            }
            if (n > 0) {
                timer = window.setTimeout(() => emit('update:count', 0), props.duration);
            }
        }, { immediate: true });
        onUnmounted(() => {
            if (timer)
                window.clearTimeout(timer);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, { name: "success-toast" }, {
                    default: _withCtx(() => [
                        (_ctx.count > 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "success-toast",
                                style: _normalizeStyle({ top: (16 + safeTop.value) + 'px' })
                            }, [
                                _createElementVNode("img", {
                                    class: "success-toast-tick",
                                    src: require('@/assets/check-tick.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_1),
                                _createElementVNode("span", _hoisted_2, _toDisplayString(displayMessage.value), 1)
                            ], 4))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
